function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0.136694,0,0,-0.0146935,198.839,266.974)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(3.20811,0,0,-3.20811,-958.783,2511.24)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#_Image1",
  x: 299.14,
  y: 23.474,
  width: "350.674px",
  height: "759.326px",
  transform: "matrix(0.999072,0,0,0.999113,0,0)"
})));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.17,1588.5L5.644,1588.5L5.644,1774.39L2.17,1774.39C1.822,1774.39 1.127,1773.32 1.127,1772.6L1.127,1589.93C0.78,1589.22 1.822,1588.5 2.17,1588.5Z",
  clipRule: "nonzero"
}));

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.17,1832.53L4.644,1832.53L4.644,2018.43L1.17,2018.43C0.822,2018.43 0.127,2017.35 0.127,2016.63L0.127,1833.97C0.127,1833.25 0.822,1832.53 1.17,1832.53Z",
  clipRule: "nonzero"
}));

var _ref5 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clip4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.475,2098.1L4.949,2098.1L4.949,2193.92L1.475,2193.92C1.127,2193.92 0.432,2192.84 0.432,2192.12L0.432,2099.53C0.432,2098.82 1.127,2098.1 1.475,2098.1Z",
  clipRule: "nonzero"
}));

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
  id: "_Image1",
  width: "351px",
  height: "760px",
  xlinkHref: "data:image/png;base64,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"
}));

var SvgTask = function SvgTask(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 837 807",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-38463.1,-10291.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.70116,0,0,40.0607,36848.2,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00009,0,0,0.627331,-9.66128,102.048)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.844133,0,0,0.844133,152.566,52.608)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.563587,0,0,0.052413,220.672,13.7692)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(248,248,248)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "1.66px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.0444543,488.97,48.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(248,248,248)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "2.6px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.0444543,417.074,48.996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(248,248,248)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "2.6px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,228.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,228.431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,233.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,233.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,230.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,230.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,234.772)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,234.772)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,237.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,237.943)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,231.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,236.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,236.358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,239.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,488.97,239.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.239005,0,0,0.00183246,417.074,231.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.181058,0,0,0.00183246,467.27,231.602)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "6.82px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.10672,0,0,0.00183246,491.872,230.809)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "11.48px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.223032,0,0,0.023974,422.338,134.468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.93px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.390088,0,0,0.0419311,321.082,58.8049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.390088,0,0,0.0419311,321.082,65.1465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.25px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.281387,0,0,0.0302466,386.968,115.688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.12px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.320838,0,0,0.0344873,363.056,98.4251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.73px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.111516,0,0,0.011987,489.93,195.017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "7.86px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.111516,0,0,0.011987,489.93,196.602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "7.86px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.088246,0,0,0.00948568,504.035,197.74)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "9.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.088246,0,0,0.00948568,504.035,198.533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "9.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.044123,0,0,0.00474284,530.779,219.519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "19.88px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.088246,0,0,0.00948568,544.154,198.533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "9.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.120783,0,0,0.00948568,514.674,199.325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "8.29px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.844133,0,0,0.844133,550.259,52.608)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.631812,0,0,0.0679143,-651.863,-49.4129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1368.73,4122.28L1567.56,4122.28C1585.01,4122.28 1599.15,4136.42 1599.15,4153.87L1599.15,4636.34C1599.15,4653.78 1585.01,4667.92 1567.56,4667.92L1368.73,4667.92C1351.29,4667.92 1337.14,4653.78 1337.14,4636.34L1337.14,4153.87C1337.14,4136.42 1351.29,4122.28 1368.73,4122.28ZM1569.05,4131.58L1538.75,4131.58C1536.12,4131.58 1534.42,4133.53 1533.81,4137.04C1531.72,4149.51 1524.92,4150.37 1522.91,4150.37L1413.38,4150.37C1411.37,4150.37 1404.49,4149.43 1402.49,4137.04C1401.94,4133.53 1400.24,4131.58 1397.54,4131.58L1367.24,4131.58C1356.26,4131.58 1346.45,4143.27 1346.45,4154.42L1346.45,4637.34C1346.45,4651.14 1360.36,4658.62 1367.01,4658.62L1569.28,4658.62C1575.93,4658.62 1589.84,4651.14 1589.84,4637.34L1589.84,4154.42C1589.92,4143.27 1580.03,4131.58 1569.05,4131.58Z",
    style: {
      fill: "rgb(248,248,248)",
      fillRule: "nonzero",
      stroke: "rgb(55,175,173)",
      strokeWidth: "1.39px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  })), _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.136694,0,0,0.0146935,191.695,218.193)"
  }, _ref3, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.943,
    y: 1583.5,
    width: 14.587,
    height: 195.896,
    style: {
      fill: "rgb(0,97,242)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.136694,0,0,0.0146935,191.832,211.022)"
  }, _ref4, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.873,
    y: 1827.53,
    width: 14.517,
    height: 195.896,
    style: {
      fill: "rgb(55,175,173)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.136694,0,0,0.0146935,191.79,204.541)"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.568,
    y: 2093.1,
    width: 14.517,
    height: 105.819,
    style: {
      fill: "rgb(55,175,173)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.713371,0,0,0.0573287,-372.973,-4.8546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.098,4123.06C922.098,4122.55 921.945,4122.05 921.671,4121.68C921.398,4121.32 921.027,4121.11 920.64,4121.11C914.974,4121.11 894.454,4121.11 888.788,4121.11C888.401,4121.11 888.03,4121.32 887.757,4121.68C887.484,4122.05 887.33,4122.55 887.33,4123.06C887.33,4123.06 887.33,4123.07 887.33,4123.07C887.33,4123.58 887.484,4124.08 887.757,4124.44C888.03,4124.81 888.401,4125.02 888.788,4125.02C894.454,4125.02 914.974,4125.02 920.64,4125.02C921.027,4125.02 921.398,4124.81 921.671,4124.44C921.945,4124.08 922.098,4123.58 922.098,4123.07C922.098,4123.07 922.098,4123.06 922.098,4123.06Z",
    style: {
      fill: "rgb(55,175,173)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "1.39px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0866441,0,0,0.0815091,212.189,-104.552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M922.098,4123.06C922.098,4121.99 914.453,4121.11 905.021,4121.11C904.817,4121.11 904.612,4121.11 904.407,4121.11C894.975,4121.11 887.33,4121.99 887.33,4123.06C887.33,4123.07 887.33,4123.07 887.33,4123.07C887.33,4124.14 894.975,4125.02 904.407,4125.02C904.612,4125.02 904.817,4125.02 905.021,4125.02C914.453,4125.02 922.098,4124.14 922.098,4123.07C922.098,4123.07 922.098,4123.07 922.098,4123.06Z",
    style: {
      fill: "rgb(55,175,173)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "1.63px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.136694,0,0,-0.0146935,198.839,266.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1028.9,2436L888.852,2436C876.705,2436 868.846,2426.99 865.988,2410.78C856.342,2353.14 824.903,2349.18 815.615,2349.18L309.383,2349.18C300.095,2349.18 268.299,2353.5 259.01,2410.78C256.51,2426.99 248.65,2436 236.146,2436L96.102,2436C45.371,2436 0,2381.96 0,2330.45L0,98.348C0,34.584 64.306,0 95.03,0L1029.97,0C1060.69,0 1125,34.584 1125,98.348L1125,2330.45C1125.36,2381.96 1079.63,2436 1028.9,2436Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(55,175,173)",
      strokeWidth: "6.42px",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0641,0,0,1.0641,203.944,-8.10957)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.447084,0,0,0.0415783,183.257,73.1214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.247,4209.92L565.433,4209.92L565.433,4642.51L866.247,4642.51L866.247,4209.92Z",
    style: {
      fill: "rgb(248,248,248)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "1.66px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,243.409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,247.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,244.038)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,396.093,243.409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,396.093,247.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,396.093,251.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,247.811)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,244.666)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,248.439)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,250.955)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,245.295)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,249.068)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,251.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,245.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,249.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,252.212)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "rgb(173,239,238)",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,246.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,250.326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.00145366,339.059,252.841)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "5.18px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.0352648,339.059,101.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "2.6px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.189598,0,0,0.0352648,396.093,101.066)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.433,
    y: 4209.92,
    width: 300.814,
    height: 432.586,
    style: {
      fill: "none",
      stroke: "rgb(55,175,173)",
      strokeWidth: "2.6px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3145,0,0,0.0338061,320.354,105.907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.21px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3145,0,0,0.0338061,320.354,106.851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.21px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.254515,0,0,0.0273582,356.712,134.932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.73px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.151661,0,0,0.0163022,419.055,182.634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "4.59px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.282718,0,0,0.0303898,339.618,123.911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.282718,0,0,0.0303898,339.618,132.53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "rgb(23,59,45)",
      strokeWidth: "2.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.282718,0,0,0.0303898,339.618,133.159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "rgb(23,59,45)",
      strokeWidth: "2.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.282718,0,0,0.0303898,339.618,133.787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "rgb(23,59,45)",
      strokeWidth: "2.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.151661,0,0,0.0163022,419.055,194.397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "rgb(23,59,45)",
      strokeWidth: "4.59px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.3145,0,0,0.0338061,320.354,110.309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.122,4257.69L743.502,4257.69",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "2.21px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5.76853,3.46683)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.533333,0,0,0.0573287,109.994,-12.1005)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 737.445,
    cy: 4585.46,
    r: 36.367,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.428118,0,0,0.046019,187.585,39.7599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 737.445,
    cy: 4585.46,
    r: 36.367,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.63px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.158747,0,0,0.0170639,386.231,172.532)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 737.445,
    cy: 4585.46,
    r: 36.367,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "4.38px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.41494,0,0,1.41494,-290.963,-83.8918)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.533333,0,0,0.0573287,380.81,-8.54098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780.433,4372.19C772.552,4364.31 768.125,4353.62 768.125,4342.48L768.125,4271.26C788.405,4270.73 808.156,4267.61 826.675,4258.48C845.738,4267.57 865.746,4271.91 886.745,4271.26L886.745,4342.48C886.745,4353.62 882.318,4364.31 874.438,4372.19C861.384,4385.24 841.414,4405.21 832.289,4414.34C831.002,4415.63 829.256,4416.35 827.435,4416.35C825.615,4416.35 823.869,4415.63 822.582,4414.34C813.456,4405.21 793.486,4385.24 780.433,4372.19Z",
    style: {
      fill: "rgb(255,115,69)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.533333,0,0,0.0573287,374.014,-7.81048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M780.433,4372.19C772.552,4364.31 768.125,4353.62 768.125,4342.48L768.125,4271.26C788.405,4270.73 808.156,4267.61 826.675,4258.48C845.738,4267.57 865.746,4271.91 886.745,4271.26L886.745,4342.48C886.745,4353.62 882.318,4364.31 874.438,4372.19C861.384,4385.24 841.414,4405.21 832.289,4414.34C831.002,4415.63 829.256,4416.35 827.435,4416.35C825.615,4416.35 823.869,4415.63 822.582,4414.34C813.456,4405.21 793.486,4385.24 780.433,4372.19Z",
    style: {
      fill: "none",
      stroke: "rgb(240,240,240)",
      strokeWidth: "0.98px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.418337,0,0,0.0449676,520.936,49.6913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.12,4240.47L752.509,4201.09L765.944,4214.52L719.838,4260.63C716.128,4264.34 710.113,4264.34 706.403,4260.63L678.884,4233.11L692.319,4219.67L713.12,4240.47Z",
    style: {
      fill: "rgb(255,250,242)"
    }
  })))))), _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTask, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/task.ec024fcb.svg";
export { ForwardRef as ReactComponent };